export const NAVIGATION_UTILISATEUR_NON_RESPONSABLE: any[] = [

  {

    'heading': true,

    'title': 'EIA'

  },

  {

    title: 'Mes EIA',

    url: '/evaluation',

    icon: 'ft-book',

    childrens: [

      {

        title: 'Moi',

        url: '/moi'

      },

      {

        title: 'Agents N-1',

        url: '/n-1'

      },

      {

        title: 'Agents N-2',

        url: '/n-2'

      },

      {

        title: 'Vue étendue',

        url: '/vue-etendue'

      },
      {
        title: 'Tableau de bord',
        url: '/',
        childrens: [
          {
            title: 'Suivi Evaluation',
            url: '/tb-suivi-evaluation',
          }
        ]
      },
      {
        title: 'Téléchargements',
        url: '/telechargement',
      }

    ]

  },


  {

    title: 'Consultations',

    url: '/consultation',

    icon: 'ft-bookmark',

    childrens: [

      {

        title: 'Mon brouillon',

        url: '/brouillon'

      },

      {

        title: 'Simulations N-1',

        url: '/simulation'

      },

    ]

  }

];

export const NAVIGATION_UTILISATEUR_NON_RESPONSABLE_HIERARCHIE: any[] = [

  {

    'heading': true,

    'title': 'EIA'

  },

  {

    title: 'Mes EIA',

    url: '/evaluation',

    icon: 'ft-book',

    childrens: [

      {

        title: 'Moi',

        url: '/moi'

      },

      {

        title: 'Agents N-1',

        url: '/n-1'

      },

      {

        title: 'Agents N-2',

        url: '/n-2'

      },

      {

        title: 'Vue étendue',

        url: '/vue-etendue',

      },
      {
        title: 'Tableau de bord',
        url: '/',
        childrens: [
          {
            title: 'Suivi Evaluation',
            url: '/tb-suivi-evaluation',
          }
        ]
      },
      {
        title: 'Téléchargements',
        url: '/telechargement',
      }

    ]
  },

  {

    title: 'Consultations',

    url: '/consultation',

    icon: 'ft-bookmark',

    childrens: [

      {

        title: 'Mon brouillon',

        url: '/brouillon'

      },

      {

        title: 'Simulations N-1',

        url: '/simulation'

      },

    ]

  }
];

export const NAVIGATION_UTILISATEUR_NON_RESPONSABLE_SANS_N1: any[] = [

  {

    'heading': true,

    'title': 'EIA'

  },

  {

    title: 'Mes EIA',

    url: '/evaluation',

    icon: 'ft-book',

    childrens: [

      {

        title: 'Moi',

        url: '/moi'

      },
      {

        title: 'Vue étendue',

        url: '/vue-etendue'
      },
      {
        title: 'Tableau de bord',
        url: '/',
        childrens: [
          {
            title: 'Suivi Evaluation',
            url: '/tb-suivi-evaluation',
          },
        ]
      },
      {
        title: 'Téléchargements',
        url: '/telechargement',
      }

    ]

  },


  {

    title: 'Consultations',

    url: '/consultation',

    icon: 'ft-bookmark',

    childrens: [

      {

        title: 'Mon brouillon',

        url: '/brouillon'

      },

      {

        title: 'Historique',

        url: '/historique-moi'

      },

    ]

  }
];

export const NAVIGATION_UTILISATEUR_NON_RESPONSABLE_SANS_N1_HIERARCHIE: any[] = [

  {

    'heading': true,

    'title': 'EIA'

  },

  {

    title: 'Mes EIA',

    url: '/evaluation',

    icon: 'ft-book',

    childrens: [

      {

        title: 'Moi',

        url: '/moi'

      },

      {

        title: 'Vue étendue',

        url: '/vue-etendue',

      },
      {
        title: 'Tableau de bord',
        url: '/',
        childrens: [
          {
            title: 'Suivi Evaluation',
            url: '/tb-suivi-evaluation',
          }
        ]
      },
      {
        title: 'Téléchargements',
        url: '/telechargement',
      }

    ]

  },


  {

    title: 'Consultations',

    url: '/consultation',

    icon: 'ft-bookmark',

    childrens: [

      {

        title: 'Mon brouillon',

        url: '/brouillon'

      },

      {

        title: 'Historique',

        url: '/historique-moi'

      },

    ]

  }
];

export const NAVIGATION_UTILISATEUR_RESPONSABLE: any[] = [

  {

    title: 'Tableau de bord',

    icon: 'ft-home',

    url: '/dashboard',

  },

  {

    'heading': true,

    'title': 'EIA'

  },

  {

    title: 'Ma structure',

    url: '/structure',

    icon: 'ft-database',

    service: 'eia',

    childrens: [{

      title: 'Campagne',

      url: '/campagne-eia',

      service: 'eia'

    },

    {

      title: 'Affectations',

      url: '/affectations-eia',

      service: 'eia'

    },

    {

      'title': 'Agents',

      'url': '/agents-structure',

      'service': 'eia'

    },
    ]

  },

  {

    title: 'Mes EIA',

    url: '/evaluation',

    icon: 'ft-book',

    childrens: [

      {

        title: 'Moi',

        url: '/moi'

      },

      {

        title: 'Agents N-1',

        url: '/n-1'

      },

      {

        title: 'Agents N-2',

        url: '/n-2'

      },

      {

        title: 'Vue étendue',

        url: '/vue-etendue'

      },

      {
        title: 'Tableau de bord',
        url: '/',
        childrens: [
          {
            title: 'Suivi Evaluation',
            url: '/tb-suivi-evaluation',
          }
        ]
      },
      {
        title: 'Téléchargements',
        url: '/telechargement',
      }
    ]

  },


  {

    title: 'Consultations',

    url: '/consultation',

    icon: 'ft-bookmark',

    childrens: [

      {

        title: 'Mon brouillon',

        url: '/brouillon'

      },

      {

        title: 'Simulations N-1',

        url: '/simulation'

      },

    ]

  }
];

export const NAVIGATION_UTILISATEUR_RESPONSABLE_HIERARCHIE: any[] = [

  {

    title: 'Tableau de bord',

    icon: 'ft-home',

    url: '/dashboard',

  },

  {

    'heading': true,

    'title': 'EIA'

  },

  {

    title: 'Ma structure',

    url: '/structure',

    icon: 'ft-database',

    service: 'eia',

    childrens: [

      {

        title: 'Campagne',

        url: '/campagne-eia',

        service: 'eia'

      },

      {

        title: 'Affectations',

        url: '/affectations-eia',

        service: 'eia'

      },

      {

        'title': 'Agents',

        'url': '/agents-structure',

        'service': 'eia'

      },
    ]

  },

  {

    title: 'Mes EIA',

    url: '/evaluation',

    icon: 'ft-book',

    childrens: [

      {

        title: 'Moi',

        url: '/moi'

      },

      {

        title: 'Agents N-1',

        url: '/n-1'

      },

      {

        title: 'Agents N-2',

        url: '/n-2'

      },

      {

        title: 'Vue étendue',

        url: '/vue-etendue'

      },
      {
        title: 'Tableau de bord',
        url: '/',
        childrens: [
          {
            title: 'Suivi Evaluation',
            url: '/tb-suivi-evaluation',
          }
        ]
      },
      {
        title: 'Téléchargements',
        url: '/telechargement',
      }
    ]

  },

  {

    title: 'Consultations',

    url: '/consultation',

    icon: 'ft-bookmark',

    childrens: [

      {

        title: 'Mon brouillon',

        url: '/brouillon'

      },

      {

        title: 'Simulations N-1',

        url: '/simulation'

      },

    ]

  }
];


export const NAVIGATION_UTILISATEUR_RESPONSABLE_SANS_N1: any[] = [

  {

    'heading': true,

    'title': 'EIA'

  },

  {

    title: 'Ma structure',

    url: '/structure',

    icon: 'ft-database',

    service: 'eia',

    childrens: [{

      title: 'Campagne',

      url: '/campagne-eia',

      service: 'eia'

    },

    {

      title: 'Affectations',

      url: '/affectations-eia',

      service: 'eia'

    },

    {

      'title': 'Agents',

      'url': '/agents-structure',

      'service': 'eia'

    },

    {

      title: 'Formations',

      url: '/formations'

    },

    ]

  },

  {

    title: 'Mes EIA',

    url: '/evaluation',

    icon: 'ft-book',

    childrens: [

      {

        title: 'Moi',

        url: '/moi'

      },

      {

        title: 'Vue étendue',

        url: '/vue-etendue'

      },

      {
        title: 'Tableau de bord',
        url: '/',
        childrens: [
          {
            title: 'Suivi Evaluation',
            url: '/tb-suivi-evaluation',
          }
        ]
      },
      {
        title: 'Téléchargements',
        url: '/telechargement',
      }
    ]

  },

  {

    title: 'Consultations',

    url: '/consultation',

    icon: 'ft-bookmark',

    childrens: [

      {

        title: 'Mon brouillon',

        url: '/brouillon'

      },

      {

        title: 'Historique',

        url: '/historique-moi'

      },

    ]

  }
];

export const NAVIGATION_UTILISATEUR_RESPONSABLE_SANS_N1_HIERARCHIE: any[] = [

  {

    'heading': true,

    'title': 'EIA'

  },

  {

    title: 'Ma structure',

    url: '/structure',

    icon: 'ft-database',

    service: 'eia',

    childrens: [{

      title: 'Campagne',

      url: '/campagne-eia',

      service: 'eia'

    },

    {

      title: 'Affectations',

      url: '/affectations-eia',

      service: 'eia'

    },

    {

      'title': 'Agents',

      'url': '/agents-structure',

      'service': 'eia'

    },
    ]

  },

  {

    title: 'Mes EIA',

    url: '/evaluation',

    icon: 'ft-book',

    childrens: [

      {

        title: 'Moi',

        url: '/moi'

      },

      {

        title: 'Vue étendue',

        url: '/vue-etendue',

      },
      {
        title: 'Tableau de bord',
        url: '/',
        childrens: [
          {
            title: 'Suivi Evaluation',
            url: '/tb-suivi-evaluation',
          }
        ]
      },
      {
        title: 'Téléchargements',
        url: '/telechargement',
      }

    ]

  },

  {

    title: 'Consultations',

    url: '/consultation',

    icon: 'ft-bookmark',

    childrens: [

      {

        title: 'Mon brouillon',

        url: '/brouillon'

      },

      {

        title: 'Historique',

        url: '/historique-moi'

      },

    ]

  }

];


